export const isMobile = __CLIENT__ ? window.isMobile : {}


// WEBPACK FOOTER //
// ./src/utils/isMobile.js